import React, { useState, useEffect } from "react";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input } from "@progress/kendo-react-inputs";
import { dropdownService } from "../../services/api/dropdown.service";
import { useLocation } from "react-router-dom";

import { SearchConsultations } from "./searchConsultations";
import { SearchPreauthorizations } from "./searchPreauthorizations";
import { SearchMMRecords } from "./searchMMRecords";
import { SearchMMPreauthorizations } from "./searchMMPreauthorizations";
import { CustomDropdown } from "../shared/customDropdown";

import { partnerService } from '../../services/api/partner.service';
import { alertService } from '../../services/helpers/alert.service';

const tryDecodeParams = (location) => {
    const searchParams = new URLSearchParams(location.search);


    try {
        var param = searchParams.get("q");
        if (param) {
            return JSON.parse(atob(param));
        }
    }
    catch {
    }

    return {};
}

export const Search = (props) => {
    const location = useLocation();
    const decodedParam = tryDecodeParams(location);
    const rol = sessionStorage.getItem('rol');
    const partener = sessionStorage.getItem('idPartener');
    const numePartener = sessionStorage.getItem('numePartener');
    const idMedic = sessionStorage.getItem('idMedic') ?? "" ;
    const numeMedic = sessionStorage.getItem('numeMedic') ?? "";
    const [doRender, setDoRender] = useState(true);
        
    // Obiectul initial pentru useState
    const initialParams = {
        partener: { id: partener, text: numePartener },
        deladata: null,
        ladata: null,
        cnp: "",
        status_finalizare: { id: -1, text: "Toate" },
        status_aprobare: { id: -1, text: "Toate" },
        numePacient: "",
        companie: "",
        emisDe: idMedic ? { id: idMedic, text: numeMedic } : null,
    };

    if (decodedParam.displayValue) {
        initialParams.deladata = decodedParam.displayValue.deladata ? new Date(decodedParam.displayValue.deladata) : null;
        initialParams.ladata = decodedParam.displayValue.ladata ? new Date(decodedParam.displayValue.ladata) : null;
        initialParams.cnp = decodedParam.displayValue.cnp ? decodedParam.displayValue.cnp : "";
        initialParams.status_finalizare = decodedParam.displayValue.status_finalizare ? decodedParam.displayValue.status_finalizare : "";
        initialParams.status_aprobare = decodedParam.displayValue.status_aprobare ? decodedParam.displayValue.status_aprobare : "";
    }


    const [params, setParams] = useState(initialParams);

    const [data, setData] = useState({
        parteneri: [],
        statusFinalizare: [{ id: -1, text: "Toate" }, { id: 0, text: "Nefinalizat" }, { id: 1, text: "Finalizat" }],
        statusAprobare: [{ id: -1, text: "Toate" }, { id: 0, text: "Neaprobat" }, { id: 1, text: "Aprobat" }],
        cnp: "",
        numePacient: "",
        companie : "",
        emisDe : [{ id: -1, text: "Toti" }]
    });

    const [activeComponent, setActiveComponent] = useState(decodedParam.activeComponent);
    const [displayValue, setDisplayValue] = useState(decodedParam.displayValue ?? {});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const parteneriResponse = await dropdownService.getPartners();
                setData((prevData) => ({ ...prevData, parteneri: parteneriResponse }));
               
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {

                const p = partener != 0 ? partener : (params?.partener?.id ?? 0);
                const medici = await partnerService.getMMDoctors({ partener: p  })
                setData((prevData) => ({ ...prevData, emisDe: medici }));

            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, [params?.partener]);


    const handleChange = (event) => {
        const { name, value } = event.target;

        if (name == "status_finalizare" && value == null) {
            setParams((prevParams) => ({ ...prevParams, status_finalizare : { id: -1, text: "Toate" } }));
            return;
        }

        if (name == "status_aprobare" && value == null) {
            setParams((prevParams) => ({ ...prevParams, status_aprobare: { id: -1, text: "Toate" } }));
            return;
        }

        if (name === "partener") {
            const selectedPartner = data.parteneri.find((partner) => partner.id == value.id);
            if (selectedPartner) {
                setParams((prevParams) => ({ ...prevParams, partener: selectedPartner }));
            }
        }
        else {
                setParams((prevParams) => ({ ...prevParams, [name]: value }));
        }
      
    };

    const restrictDate = (deladata, ladata) => {
        var dif = (ladata - deladata) / (24 * 3600 * 1000)
        if (dif >= 0 && dif < 92) return false;
        return true;
    }


    const handleClick = (componentName) => {

        if (rol == 2 && componentName != "MMRecords") {
            alertService.error("Nu aveti acces la aceasta pagina!");
            return;
        }

        if (rol != 3 & params.partener.id == 0
            && !params.deladata && !params.ladata) {
                alertService.error("Nu poti selecta Toti partenerii fara a alege si o perioada!");
                return
        }

        if (params.deladata != null && params.ladata == null || params.deladata == null && params.ladata != null) {
            alertService.error("Trebuie sa completezi ambele campuri De la data si la data!");
            return
        }

        if (params.deladata > params.ladata) {
            alertService.error("Campul De la data nu poate fi mai mare decat campul La data!");
            return;
        }

        if (restrictDate(params.deladata, params.ladata)) {
            alertService.error("Nu puteti cauta pe o perioada mai mare de 3 luni");
            return;
        }


        setDisplayValue(params);
        setActiveComponent(componentName);
    };

    const renderSearchComponent = () => {


        switch (activeComponent) {
            case "Consultations":
                return <SearchConsultations params={displayValue} activeComponent={activeComponent} />;
            case "Preauthorizations":
                return <SearchPreauthorizations params={displayValue} activeComponent={activeComponent} />;
            case "MMRecords":
                return <SearchMMRecords params={displayValue} activeComponent={activeComponent} />;
            case "MMPreauthorizations":
                return <SearchMMPreauthorizations params={displayValue} activeComponent={activeComponent} />;
            default:
                return null;
        }
    };

    return (
        <>
            <h2>Cautare</h2>
            <div className="formular cautare" data-name="cautare">
                <fieldset>
                    <table>
                        <tbody>
                            <tr>
                                <td width="280">
                                    <label className="pb5">Partener</label>
                                    <DropDownList
                                        className="text w250"
                                        data={data.parteneri}
                                        type="text"
                                        name="partener"
                                        value={params.partener}
                                        textField="text"
                                        dataItemKey="id"
                                        onChange={handleChange}
                                        disabled={data.parteneri.length === 1}
                                    />
                                </td>
                                <td width="280">
                                    <label className="pb5">De la data</label>
                                    <DatePicker
                                        className="text w250"
                                       
                                        name="deladata"
                                        value={params.deladata}
                                        onChange={handleChange}
                                    />
                                </td>
                                <td width="280">
                                    <label className="pb5">La data</label>
                                    <DatePicker
                                        className="text w250"
                                       
                                        name="ladata"
                                        value={params.ladata}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                            <td>
                                <label className="pt15 pb5">CNP</label>
                                <Input
                                    className="w250"
                                    name="cnp"
                                    maxLength="13"
                                    value={params.cnp}
                                    onChange={handleChange}
                                />
                            </td>
                            <td>
                                <label className="pt15 pb5">Status finalizare</label>
                                <ComboBox
                                    name="status_finalizare"
                                    type="text"
                                    className="w250 fl"
                                    value={params.status_finalizare}
                                    data={data.statusFinalizare}

                                    textField="text"
                                    dataItemKey="id"
                                    onChange={handleChange}
                                />
                            </td>
                            <td>
                                <label className="pt15 pb5">Status aprobare</label>
                                <ComboBox
                                    name="status_aprobare"
                                    type="text"
                                    className="w250 fl"
                                    value={params.status_aprobare}
                                    data={data.statusAprobare}
                                    textField="text"
                                    dataItemKey="id"
                                    onChange={handleChange}
                                />
                            </td>
                            </tr>
                            <tr>
                                <td>
                                    <label className="pt15 pb5">Nume pacient</label>
                                    <Input
                                        className="w250"
                                        name="numePacient"
                                        maxLength="30"
                                        value={params.numePacient}
                                        onChange={handleChange}
                                    />
                                </td>
                                <td>
                                    <label className="pt15 pb5">Companie</label>
                                    <Input
                                        name="companie"
                                        type="text"
                                        className="w250 fl"
                                        value={params.companie}
                                        onChange={handleChange}
                                    />
                                </td>
                                <td>
                                    <label className="pt15 pb5">Emis de</label>
                                    <ComboBox
                                        name="emisDe"
                                        type="text"
                                        className="w250 fl"
                                        value={params.emisDe}
                                        data={data.emisDe}
                                        textField="text"
                                        dataItemKey="id"
                                        onChange={handleChange}
                                        defaultItem={{ id: idMedic, text: numeMedic }}
                                    />
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <ul className="submenu pt20 clearfix">
                        <li className="fl">
                            <button
                                className={activeComponent == "Consultations" ? "button_activ" : ""}
                                data-name="cautare_consultatii"
                                name="cautare_consultatii"
                                onClick={() => handleClick("Consultations")}
                            >
                                Cauta consultatii
                            </button>
                        </li>
                        <li className="fl">
                            <button
                                className={activeComponent == "Preauthorizations" ? "button_activ" : ""}
                                data-name="cautare_preautorizari"
                                name="cautare_preautorizari"
                                onClick={() => handleClick("Preauthorizations")}
                            >
                                Cauta preautorizari
                            </button>
                        </li>
                        <li className="fl">
                            <button
                                className={activeComponent == "MMPreauthorizations" ? "button_activ" : ""}
                                data-name="cautare_preautorizari_mm"
                                name="cautare_preautorizari_mm"
                                onClick={() => handleClick("MMPreauthorizations")}
                            >
                                Cauta preautorizari MM
                            </button>
                        </li>
                        <li className="fl">
                            <button
                                className={activeComponent == "MMRecords" ? "button_activ" : ""}
                                data-name="cautare_fise_mm"
                                name="cautare_fise_mm"
                                onClick={() => handleClick("MMRecords")}
                            >
                                Cauta fise MM
                            </button>
                        </li>
                    </ul>
                </fieldset>
                <div data-name="rezultat">{renderSearchComponent()}</div>
            </div>
        </>
    );
};